import { createBlock } from 'factories/block';

export const oldStylesToNewMap = {
  buttonShadow: 'shadow',
  buttonOutline: 'outline',
  buttonShape: 'shape',
  background: 'backgroundColor',
  buttonBackgroundOpacity: 'backgroundOpacity',
  buttonHover: 'backgroundColorOnHover',
  buttonHoverBackgroundOpacity: 'backgroundOpacityOnHover',
  color: 'textColor',
  textHoverColor: 'textColorOnHover',
  buttonOutlineColor: 'outlineColor',
};
export const oldDataToNewMap = {
  id: 'id',
  label: 'label',
  location: 'location',
  linkData: 'linkData',
  fontFamily: 'fontFamily',
  // fontSize: 'fontSize',
  bold: 'bold',
  uppercase: 'uppercase',
  useLargeButton: 'useLargeButton',
  borderRadius: 'borderRadius',
  focusColor: 'focusColor',
};

export const oldButtonPropsToNewMap = {
  buttonShadow: 'shadow',
  buttonOutline: 'outline',
  buttonShape: 'shape',
  background: 'backgroundColor',
  buttonBackgroundOpacity: 'backgroundOpacity',
  buttonHover: 'backgroundColorOnHover',
  buttonHoverBackgroundOpacity: 'backgroundOpacityOnHover',
  color: 'textColor',
  textHoverColor: 'textColorOnHover',
  buttonOutlineColor: 'outlineColor',
  //
  id: 'id',
  label: 'label',
  location: 'location',
  linkData: 'linkData',
  fontFamily: 'fontFamily',
  fontSize: 'fontSize',
  bold: 'bold',
  uppercase: 'uppercase',
  useLargeButton: 'useLargeButton',
  borderRadius: 'borderRadius',
  focusColor: 'focusColor',
};

export const createContinueBtn = (props = {}) => {
  return createBlock('ContinueButton', 'Continue' as any, {
    props: {
      label: 'Continue',
      location: 'next',
      ...props,
    },
    meta: { subType: 'continue' },
  });
};
